angular.module('leanlaw').controller('AttorneyRevenueCtrl', ['$scope', '$rootScope', '$filter', '$window', '$state', 'alerts', 'userService', 'reportsService', 'singleRequest', 'accountingService', 'exportJson', 'messageBus', 'leanLawAuth', function ($scope, $rootScope, $filter, $window, $state, alerts, userService, reportsService, singleRequest, accountingService, exportJson, messageBus, leanLawAuth) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = '';
  $scope.format = {};
  $scope.sort = 'user.name';
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    $window.print();
  };
  $scope.allocations = function () {
    alerts.success('Payment allocation detail will be downloaded to a CSV file');
    const {
      status,
      scope,
      scopeAccount,
      range,
      distributionId,
      filter
    } = $scope.filter;
    let query = `status=${status}&scope=${scope}`;
    if (scopeAccount || filter?.scopeAccount?.id) {
      query += `&scopeAccount=${scopeAccount || filter?.scopeAccount?.id}`;
    }
    if (distributionId) {
      query += `&distributionId=${distributionId}`;
    } else {
      if (range.startDate) {
        query += `&startDate=${range.startDate.toNetworkDate()}`;
      }
      if (range.endDate) {
        query += `&endDate=${range.endDate.toNetworkDate()}`;
      }
    }
    $window.location = `${leanLawAuth.domain}/v1/payments/allocations/csv?${query}`;
  };
  function itemData(item, data) {
    item['Worked'] = $filter('amount')(data.collected.servicesTotal);
    item['Worked Share'] = $filter('amount')(data.origination.share);
    item['Origination'] = $filter('amount')(data.origination.originatorDebit);
    if ($scope.me.company.settings.report?.responsibleContribution) {
      item['Responsible'] = $filter('amount')(data.origination.responsibleDebit);
    }
    if ($scope.me.features.referral) {
      item['Referrals'] = $filter('amount')(data.origination.referralDebit);
    }
    if ($scope.me.company.settings.report?.customPlan) {
      item['Firm Share'] = $filter('amount')(data.origination.firmDebit);
    }
    item['Total'] = $filter('amount')(data.origination.adjusted);
    if ($scope.filter.showExpense) {
      item['Expenses'] = $filter('amount')(data.collected.expensesUsers);
    }
    if ($scope.me.features.referral && $scope.data.data.collected.expensesServices) {
      item['Service Expenses'] = $filter('amount')(data.collected.expensesServices);
    }
  }
  $scope.export = function () {
    const lead = $scope.me.terms.Lead;
    const exp = $scope.data.filtered.map(user => {
      const item = {
        [lead]: user.user.name
      };
      itemData(item, user.data);
      return item;
    }, []);
    exportJson.downloadCsv(exp);
  };

  // MatterId may be optional
  $scope.gotoDetail = function (user) {
    $state.go('reports.attorney-revenue-detail', {
      id: user.id,
      return: 'reports.attorney-revenue',
      report: `Revenue for ${user.name}`
    });
  };
  $scope.generic = id => {
    $state.go('reports.generic', {
      id
    });
  };
  activate();

  ///////////////////////////////////////

  async function activate() {
    const me = await userService.me();
    $scope.me = me;
    const status = await accountingService.verify(false);
    $scope.accounting = status.connected;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      if (payload.filter.range) {
        filterClientEntries();
      }
    });
    $scope.$on('report-sidebar-filterchange', (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage('filterDependency-ready', true);
  }
  function filterClientEntries() {
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'accounts';
    query.billingType = '-internal';
    query.zeros = false;
    query.data = 'payments';
    query.reportType = 'revenue';
    $scope.loading = true;
    singleRequest.apiCall('attorney-revenue', true).getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      $scope.data = data;
      $scope.firm = Math.round((data.data.origination.firmCredit - (data.data.origination.firmDebit || 0)) * 100) / 100;
      const i = data.unallocated?.amounts?.unallocatedInvoiced;
      const c = data.unallocated?.collected;
      const totalCollected = data.data?.collected?.servicesTotal + c?.expensesUnassigned + data.data?.collected?.expensesUsers + c?.servicesUnassigned + c?.nonLeanLaw;
      $scope.unallocated = {
        show: !!(i?.expenses || i?.charges || c?.expensesUnassigned || c?.chargesTotal || c?.nonLeanLaw),
        totalCollected: totalCollected,
        totalAfterTax: totalCollected + c?.tax,
        totalInvoiced: data.data?.amounts?.invoiced + i?.expenses + i?.charges
      };
    }).catch(err => {
      console.error('There was an error loading the report:', err);
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel('attorney-revenue');
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.users, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.users', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);